"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRemoveAccessibleCategories = exports.getAccessibleCategories = exports.categoryContainsGroups = exports.getCategoryByType = exports.getCategoryById = exports.getGroupById = exports.getGroupsByCategoryId = exports.isCategoryGroup = void 0;
exports.getLocalizedUserGroupName = getLocalizedUserGroupName;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
function getLocalizedUserGroupName(groupname) {
    switch (groupname) {
        case 'Light Admins':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/lightAdmins');
        case 'WorksiteDiaryMaster':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryMaster');
        case 'WorksiteDiarySuperVisor':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediarySupervisor');
        case 'WorksiteDiaryUser':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryUser');
        case 'TRMVRMeterEmployer':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/trmvrMeterEmployer');
        case 'TRMVRMeterEmployee':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/trmvrMeterEmployee');
        case 'TRMVRMeterPreview':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/trmvrMeterPreview');
        default:
            return groupname;
    }
}
var isCategoryGroup = function (group) { return !group.categoryId; };
exports.isCategoryGroup = isCategoryGroup;
var getGroupsByCategoryId = function (groups, categoryId) { return groups.filter(function (group) { return group.categoryId === categoryId; }); };
exports.getGroupsByCategoryId = getGroupsByCategoryId;
var getGroupById = function (groups, groupId) {
    return groups.find(function (group) { return group.id === groupId; });
};
exports.getGroupById = getGroupById;
var getCategoryById = function (categories, categoryId) { return categories.find(function (cat) { return cat.category.id === categoryId; }); };
exports.getCategoryById = getCategoryById;
var getCategoryByType = function (categories, type) {
    var cat = categories.find(function (cat) { return cat.category.type === type; });
    return cat && cat.category;
};
exports.getCategoryByType = getCategoryByType;
var categoryContainsGroups = function (category, groups) {
    var groupIds = groups.map(function (group) { return group.id; });
    return category.groups.every(function (groupInCategory) {
        return groupIds.includes(groupInCategory.id);
    });
};
exports.categoryContainsGroups = categoryContainsGroups;
var getAccessibleCategories = function (perm, groups) {
    return groups.filter(function (f) {
        switch (f.category.type) {
            case 'ProjectAdminUserGroup':
            case 'SokoBidAdminUserGroup':
                return acl.isSuperAdmin(perm);
            case 'CategoryUserGroup':
            case 'NormalUserGroup':
                return acl.isLightAdmin(perm);
            case 'LightAdminCategoryUserGroup':
            case 'LightAdminUserGroup':
                return acl.isProjectAdmin(perm);
            case 'SokoBidCategoryUserGroup':
            case 'SokoBidUserGroup':
                return acl.isSokoBidAdmin(perm);
            case 'WorksiteDiaryUserGroup':
            case 'UserProfileWorksiteDiaryMaster':
            case 'UserProfileWorksiteDiarySupervisor':
            case 'UserProfileWorksiteDiaryUser':
            case 'TRMVRUserGroup':
            case 'UserProfileTRMVREmployer':
            case 'UserProfileTRMVREmployee':
            case 'UserProfileTRMVRPreview':
                return acl.isProjectAdmin(perm);
            default:
                return false;
        }
    });
};
exports.getAccessibleCategories = getAccessibleCategories;
var getRemoveAccessibleCategories = function (perm, groups) {
    return groups.filter(function (f) {
        switch (f.category.type) {
            case 'SokoBidAdminUserGroup':
                return acl.isSuperAdmin(perm);
            case 'ProjectAdminUserGroup':
            case 'CategoryUserGroup':
            case 'NormalUserGroup':
                return acl.isProjectAdmin(perm);
            case 'LightAdminCategoryUserGroup':
            case 'LightAdminUserGroup':
                return acl.isLightAdmin(perm);
            case 'SokoBidCategoryUserGroup':
            case 'SokoBidUserGroup':
                return acl.isSokoBidAdmin(perm);
            case 'WorksiteDiaryUserGroup':
            case 'UserProfileWorksiteDiaryMaster':
            case 'UserProfileWorksiteDiarySupervisor':
            case 'UserProfileWorksiteDiaryUser':
            case 'TRMVRUserGroup':
            case 'UserProfileTRMVREmployer':
            case 'UserProfileTRMVREmployee':
            case 'UserProfileTRMVRPreview':
                return acl.isProjectAdmin(perm);
            default:
                return false;
        }
    });
};
exports.getRemoveAccessibleCategories = getRemoveAccessibleCategories;
